import http from '../utils/fetch'

export default {
  // 不包含参保人信息
  fetchCompanies (success, error) {
    http.get({url: 'companies'})
      .then(res => {
          // debugger
          success(res.filter(company => !company.isInsured))
        },
        res => error(res))
  },
  fetchAllCompanies (success, error) {
    http.get({url: 'companies'})
      .then(res => {
          success(res)
        },
        res => error(res))
  },

  postCompany (company, success, error) {
    http.post({
      url: 'companies',
      data: company
    })
      .then(res => success(res), res => error(res))
  },

  putCompany (company, success, error) {
    http.put({
      url: `companies/${company.customerId}`,
      data: company
    })
      .then(res => success(res), res => error(res))
  },

  fetchCompany (companyId, success, error) {
    http.get({url: `companies/${companyId}`})
      .then(res => success(res), res => error(res))
  },

  deleteCompany (companyId, success, error) {
    http.delete({url: `companies/${companyId}`})
      .then(res => success(res), res => error(res))
  }
}



// WEBPACK FOOTER //
// ./src/api/company.js